import { getQuickCommentsApi, editQuickCommentsApi } from 'library-@/apis/workspace_api/comments';
import _ from 'lodash';

class QuickCommentService {
    constructor() {
        this.cacheData = {};
    }

    async getQuickComments() {
        if (_.isEmpty(this.cacheData)) {
            this.cacheData = await getQuickCommentsApi();
        }
        return Promise.resolve(this.cacheData);
    }

    editQuickComments(commentId, commentList) {
        this.cacheData = {};
        return editQuickCommentsApi(commentId, commentList);
    }
}

export default new QuickCommentService();
